import React from "react";
import { Icon } from "@amzn/awsui-components-react";

export const INFO_TABLE_COLUMN_DEFINITIONS = [
    {
        id: "name",
        header: () => "Property Name",
        cell: (item: any) => item.key,
        width: 360
    },
    {
        id: "value",
        header: () => "Property Value",
        cell: (item: any) => {
            // Check if this is the userStatus field and customize based on value
            if (item.key === "userStatus") {
                const status = item.value?.toLowerCase();
                if (status === "active") {
                    return (
                        <span>
                            Active. Ready to go! <Icon name="status-positive" />
                        </span>
                    );
                } else if (status === "unknown") {
                    return (
                        <span>
                            Unknown. This usually means you need to activate (see button below) <Icon name="status-pending" />
                        </span>
                    );
                } else if (status === "activating") {
                    return (
                        <span>
                            Activating. This usually takes 30 minutes, enough for a coffee <Icon name="status-pending" />
                        </span>
                    );
                }
            }
            
            // Add link for awsAccountId
            if (item.key === "awsAccountId") {
                return (
                    <span>
                        {item.value} [<a href={`https://conduit.security.a2z.com/accounts/aws/${item.value}/attributes`} target="_blank" rel="noopener noreferrer">View in Conduit</a>]
                    </span>
                );
            }
            
            // Add link for awsAccountOwnerTeamId
            if (item.key === "awsAccountOwnerTeamId") {
                return (
                    <span>
                        {item.value} [<a href={`https://permissions.amazon.com/a/team/${item.value}`} target="_blank" rel="noopener noreferrer">View in Team</a>]
                    </span>
                );
            }
            
            // Add link for userAlias
            if (item.key === "userAlias") {
                return (
                    <span>
                        {item.value} [<a href={`https://phonetool.amazon.com/users/${item.value}`} target="_blank" rel="noopener noreferrer">View in Phonetool</a>]
                    </span>
                );
            }
            
            return item.value;
        },
    }
];
